import { localize } from '../helpers';

export const templates = (translations: Record<string, string>, module: string) => {
    const data = {
        findNdsPayer: {
            pdf: '/uploads/Инструкция API сервиса Поиск НДС.pdf',
            nameServices: localize('find-nds-payer-service-search-vat-data', translations) + ':',
            link: '[portal-host]/services/isnaportal/public/find-nds-payer/search-in-knp',
            method: 'POST',
            params:
                localize('api-print-logical', translations) +
                '\n' +
                localize('api-print-false', translations) +
                '\n' +
                localize('api-print-true', translations),
            titleBody: localize('api-request-body', translations),
            requestBody: `
//Поиск данных о плательщике НДС
{
    "iinBin": "iinBin", "type": "SEARCH"
}
//Проверка на соответствие номера и серии свидетельства НДС 
{
    "iinBin": "iinBin", 
    "number": "number", 
    "series": "series", 
    "type": "CHECK"
}`,
            resultExample: `
{
    "name": "np_name",
    "iinBin": "iin",
    "rnn": "rnn",
    "beginDate": null,
    "endDate": null,
    "reason": null,
    "certificateInfo": null
}`,
        },
        ServiceUnreliableTaxpayers: {
            nameServices: 'Поиск неблагонадежных НП:',
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search',
            method: 'POST',
            params: `-`,
            titleBody: 'Тело запроса: JSON-объект вида:',
            requestBody: `
{
    "iinBin": "string",
    "number": "string",
    "rnn": "string",
    "series": "string",
    "type": "SEARCH"
}`,
            resultExample: `
{
    "name": "name", 
    "iinBin": "iinBin", 
    "rnn": null, 
    "beginDate": null, 
    "endDate": null, 
    "reason": null, 
    "certificateInfo": null
}`,
        },
        FindTaxpayerService: {
            pdf: '/uploads/Инструкция API сервиса Поиск НП.pdf',
            nameServices: localize('api-search-tp', translations),
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search-in-knp',
            method: 'POST',
            params:
                localize('api-print-logical', translations) +
                '\n' +
                localize('api-print-false', translations) +
                '\n' +
                localize('api-print-true', translations),
            titleBody: localize('api-request-body', translations),
            requestBody: `
//${localize('api-for-ie', translations)} 
{  
    "iinBin": "iinBin", 
    "status": "ALL"
}

//${localize('api-for-pepp', translations)}
{
    "type": "LZCHP",
    "iinBin": "iinBin"
}

//${localize('api-for-le', translations)} 
{
    "type": "UL",
    "iinBin": "iinBin"
}`,
            resultExample: `
//${localize('api-for-ie', translations)}
{
    "results": [
        {
            "name": "NPtype,
            "type": "IP",
            "lzchpType": null,
            "iinBin": "iinBin",
            "rnn": "rnn",
            "beginDate": "dd.mm.yyyy",
            "endDate": null,
            "reason": null,
            "suspensionPeriod": null,
            "ulTaxInfo": null
        }
    ]
}

//${localize('api-for-pepp', translations)}
{
    "results": [
        {
            "name": "NPname",
            "type": "LZCHP",
            "lzchpType": "LAWYER",
            "iinBin": "iinBin",
            "rnn": "rnn",
            "beginDate": "dd.mm.yyyy",
            "endDate": "dd.mm.yyyy",
            "reason": "reason",
            "suspensionPeriod": "suspensionPeriod",
            "ulTaxInfo": null
        }
    ]
}
         
//${localize('api-for-le', translations)}
{
    "results": [
        {
            "name": "ULname",
            "type": "UL",
            "lzchpType": null,
            "iinBin": "iinBin",
            "rnn": "rnn",
            "beginDate": "dd.mm.yyyy",
            "endDate": "dd.mm.yyyy",
            "reason": "reason",
            "suspensionPeriod": "suspensionPeriod",
            "ulTaxInfo": [
                {
                    "year": year,
                    "taxIncome": "taxIncomeSum",
                    "vatReturn": "vatReturnSum"
                }
            ]
        }
    ]
}`,
        },
        FindLiquidatedTaxpayer: {
            nameServices: 'Поиск НП на стадии ликвидации:',
            link: 'https://portal.kgd.gov.kz/services/isnaportalsync/public/find-liquidated-taxpayer',
            method: 'GET',
            params: `
                date: <yyyy-mm-dd>
                taxpayerCode: <ИИН/БИН>
                name: <Наименование>
                fio: <ФИО>
                rnn: <РНН>
            `,
            resultExample: `
                []
            `,
        },
        FindRiskDegreeService: {
            nameServices: localize('api-risk-degree-category', translations),
            link: '[portal-host]/services/isnaportalsync/public/find-risk-degree',
            method: 'GET',
            params:
                localize('api-print-taxpayerCode', translations) +
                '\n' +
                localize('api-print-logical', translations) +
                '\n' +
                localize('api-print-false', translations) +
                '\n' +
                localize('api-print-true', translations),
            resultExample: `
{
    "taxpayerCode" : "iinBin",
    "name" : "NP name",
    "degree" : "degreeCode",
    "relevanceDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "beginDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "endDate" : "yyyy-mm-ddT00:00:00.000+00:00"
}`,
        },
        InfoAbsenceTaxDebt: {
            nameServices: 'Cведения об отсутствии (наличии) налоговой задолженности:',
            link: '[portal-host]/services/isnaportalsync/public/tax-debt-info',
            method: 'GET',
            params: `${localize('api-print-taxpayerCode', translations)}
- rnn - РНН налогоплательщика, строковый, обязательный
- print - логический, обязательный:
- false - возвращать результат запроса в виде JSON
- true - возвращать результат в виде печатной формы (pdf-документ в формате base64`,
            resultExample: `
{
    "messageId": "mock-message-id",
    "sendTime": "timestamp",
    "iinBin": "iiBin",
    "nameRu": "NPnameRu",
    "nameKz": "NPnameKz",
    "totalArrear": 0.00,
    "totalTaxArrear": 0.00,
    "pensionContributionArrear": 0.00,
    "socialContributionArrear": 0.00,
    "socialHealthInsuranceArrear": 0.00,
    "taxOrgInfo": [ 
        {
            "charCode": "charCode",
            "nameRu": "nameRu",
            "nameKz": "nameKz",
            "reportAcrualDate": "yyyy-mm-ddTT00:00:00.000+00:00",
            "totalArrear": 0.00,
            "totalTaxArrear": 0.00,
            "pensionContributionArrear": 0.00,
            "socialContributionArrear": 0.00,
            "socialHealthInsuranceArrear": 0.00,
            "taxPayerInfo": [ 
                {
                    "iinBin": "iinBin",
                    "nameRu": "NPnameRu",
                    "nameKz": "NPnameKz",
                    "bccArrearsInfo": [ 
                        {
                            "bcc": "bccCode",
                            "bccNameRu": "bccNameRu",
                            "bccNameKz": "bccNameRu",
                            "taxArrear": 0.00,
                            "poenaArrear": 0.00,
                            "percentArrear": 0.00,
                            "fineArrear": 0.00,
                            "totalArrear": 0.00
                        }
                    ]
                }
            ]
        }
    ]
}`,
        },
        BankruptService: [
            {
                nameServices: 'Регистрация в сервисе по процедурам банкротства',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/request-access',
                method: 'POST',
                params: `-`,
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody: `
{
   "iinBin": "string",
   "serviceType": "string",
   "token": "string"
}`,
                resultExample: `
{
  "errors": [
    {
      "code": "string",
      "en": "string",
      "kk": "string",
      "param": "string",
      "ru": "string"
    }
  ],
  "status": "string",
  "token": "string"
}`,
            },
            {
                nameServices: 'Удаление регистрации ИИН/БИН на сервис:',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/remove-access',
                method: 'POST',
                params: `-`,
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody: `
{
   "iinBin": "string",
   "serviceType": "string",
   "token": "string"
}`,
                resultExample: `
{
  "errors": [
    {
      "code": "string",
      "en": "string",
      "kk": "string",
      "param": "string",
      "ru": "string"
    }
  ],
  "status": "string",
  "token": "string"
}`,
            },
            {
                nameServices: 'Получения сведений по должнику:',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/event-data',
                method: 'POST',
                params: `-`,
                titleBody: 'Тело запроса: JSON-объект вида:',
                requestBody: `
{
  "iinBin": "string",
  "orgIinBin": "string",
  "serviceType": "string",
  "token": "string"
}`,
                resultExample: `
{
  "eventDate": "string",
  "eventType": 0,
  "iinBin": "string"
}`,
            },
            {
                nameServices: 'Получения справочника типов сервисов:',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/service-types',
                method: 'GET',
                params: `-`,
                resultExample: `
{
  "code": "string",
  "en": "string",
  "hasChild": true,
  "id": 0,
  "kk": "string",
  "qq": "string",
  "rank": "string",
  "ru": "string"
}`,
            },
            {
                nameServices: 'Получения списка всех активных регистраций или по ИИН/БИН:',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/active-accesses',
                method: 'GET',
                params: `-`,
                resultExample: `
{
  "iinBin": "string",
  "serviceType": "string",
  "token": "string"
}`,
            },
        ],
    };
    const result = data[module];
    return Array.isArray(result) ? { services: result } : result;
};
